import React from 'react';
import styled from 'styled-components';

const VisuallyHidden = styled.div`
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  white-space: nowrap;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
`;

interface LiveAnnouncerProps {
  isUser: boolean;
  message?: {
    type: string;
    text: string;
    author: {
      __typename: string;
      name: string;
    };
  };
}

const LiveAnnouncer = function ({
  isUser,
  message = undefined,
}: LiveAnnouncerProps) {
  const author = isUser ? 'UserAuthor' : 'ExpertAuthor';
  let announcement = message?.type === 'typing'
    ? `${message.author.name} is typing`
    : '';
  // eslint-disable-next-line no-underscore-dangle
  announcement ||= (message?.author.__typename !== author && message?.text) || '';

  return (
    <VisuallyHidden aria-live="polite" role="log" aria-atomic="true">
      {announcement}
    </VisuallyHidden>
  );
};

export default LiveAnnouncer;
